import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const hideDurationBySeverity = {
  success: 5000,
  info: 5000,
  warning: 5000,
  error: 7000,
};

function AppSnackbar({ open, message, severity = "info", onClose }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;

    const readingTime = typeof message === "string" ? message.length * 60 : 0;
    const duration = Math.min(9000, Math.max(hideDurationBySeverity[severity], readingTime));
    const timeout = window.setTimeout(() => onCloseRef.current(null, "timeout"), duration);
    return () => window.clearTimeout(timeout);
  }, [open, message, severity]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={null}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{
        width: { xs: "calc(100vw - 32px)", sm: "auto" },
        maxWidth: "calc(100vw - 32px)",
      }}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={onClose}
        closeText="Cerrar notificación"
        sx={{
          alignItems: "center",
          width: "100%",
          minWidth: { sm: 320 },
          maxWidth: 560,
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.18)",
          px: 2,
          py: 1.25,
          "& .MuiAlert-message": {
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.45,
            overflowWrap: "anywhere",
          },
          "& .MuiAlert-icon": { alignItems: "center", py: 0 },
          "& .MuiAlert-action": { alignItems: "center", pl: 1.5, pt: 0 },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

AppSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.node.isRequired,
  severity: PropTypes.oneOf(["success", "info", "warning", "error"]),
  onClose: PropTypes.func.isRequired,
};

export default AppSnackbar;
